export function loadCircleChart(
  myChart,
  data,
  fontSizes,
  widths,
  itemGaps
  // unit = "万元"
) {
  let total = 0;
  data.forEach(ele => {
    total += Number(ele.value);
  });

  myChart.setOption({
    title: [
      {
        show: false,
        text: "面积占比",
        top: "center",
        left: "22%",
        textStyle: {
          color: "#fff",
          fontSize: 12
        }
      }
    ],
    color: [
      "#FE9059",
      "#5C7BD9",
      "#9FE080",
      "#FFDC60",
      "#FF7070",
      "#58D5FF",
      "#EA7CCC"
    ],
    legend: {
      show: true,
      right: "8%",
      itemGap: itemGaps,
      // y: "center",
      top: "23%",
      itemWidth: widths,
      itemHeight: widths,
      orient: "vertical",

      formatter: function(e) {
        let val = data.find(it => {
          return e === it.name;
        });
        const percent = (val.value / total) * 100;
        return e + " (" + percent.toFixed(2) + "%)";
        //return e + ": " + val.value + unit + "(" + percent.toFixed(2) + "%)";
      },
      textStyle: {
        color: "#fff",
        fontSize: fontSizes
      }
    },
    tooltip: {
      trigger: "item",
      formatter: "{b} : {d}%"
      // formatter: "{b} : {c}" + unit + " ({d}%)"
    },
    series: [
      // 主要展示层的
      {
        radius: ["60%", "83%"],
        center: ["28%", "58%"],
        type: "pie",
        label: {
          show: false
        },
        labelLine: {
          show: false
        },
        data: data
      },
      // 边框的设置
      {
        radius: ["50%", "54%"],
        center: ["28%", "58%"],
        type: "pie",
        label: {
          normal: {
            show: false
          },
          emphasis: {
            show: false
          }
        },
        labelLine: {
          normal: {
            show: false
          },
          emphasis: {
            show: false
          }
        },
        animation: false,
        tooltip: {
          show: false
        },
        data: [
          {
            value: 1,
            itemStyle: {
              color: "rgba(250,250,250,0.3)"
            }
          }
        ]
      }
    ]
  });
}
